<template>
    <!-- 直播维护 -->
    <div>
        <!-- <DataList :dataArray="courseList" @transfer="toDetail" /> -->
        <ul class="wrap_lis" v-if="courseList.length > 0">
            <div v-for="(item, index) in courseList" :key="index">
                <li class="wrap_li" @click="toDetail(item)">
                    <div class="img_wrap">
                        <el-image :src="pic + item.videoAvatar" lazy draggable="false"></el-image>
                        <div class="img_bottom">
                            <!-- <img src="../../assets/img/view.png" draggable="false" /> -->
                            <span>{{ item.createTime }}</span>
                            <span class="c_num">{{ item.totalPrice }}</span>
                        </div>
                    </div>
                    <div class="li_desc">
                        <p class="v_desc" :title="item.courseTitle">{{ item.courseTitle }}</p>
                        <div class="v_author">
                            <div v-for="(expert, index2) in item.expertNames" :key="index2">
                                <span>{{ expert.expertName }}</span>
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </ul>
        <div v-else>
            <div class="noData flexColum">
                <img src="@/assets/img/none.png" alt="" />
                <p>暂无内容</p>
            </div>
        </div>
    </div>
</template>

<script>
import DataList from "../Common/DataList";

export default {
    name: "MyVideo",
    data() {
        return {
            pic: "https://www.orthoday.com/SDpic/common/picSelect?gid=",
            courseList: [],
            expertName: ""
        };
    },
    components: { DataList },
    created() {
        this.getDataList();
    },
    methods: {
        getDataList() {
            let params = {
                type: "4"
            };
            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post("/SD/orderinfo/queryOrderAuth", this.$qs.stringify(params), { headers })
                .then(res => {
                    if (res.data.code == "1") {
                        this.courseList = res.data.result_data;
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch(err => {
                });
        },
        toDetail(dic) {
            var gid = dic.courseGid;
            this.$router.push({ path: "/classVideo", params: { gid: gid }, query: { gid: gid }});

        }
    }
};
</script>
<style scoped src="../../assets/css/data-list.css"></style>
<style scoped lang="less">
.noData {
    display: flex;
    padding-top: 170px;
    img {
        width: 300px;
    }
}
</style>
